import { put, takeLatest } from "redux-saga/effects";
import { getInfomationStoreDetailApi } from "store/api/InfomationStoreApi";
import { GET_INFOMATION_STORE_DETAIL_ACTION } from "../../actions/InfomationStorePageAction/actionTypes";

import * as infomationStorePageAction from "../../actions/InfomationStorePageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getInfomationStoreDetail() {
	const res = yield getInfomationStoreDetailApi();
	try {
		if (res?.code === 0) {
			yield put(
				infomationStorePageAction.setInfomationStoreDetailAction(
					res?.data
				)
			);
		} else {
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	}
}

function* getInfomationStoreDetailSaga() {
	yield takeLatest(
		GET_INFOMATION_STORE_DETAIL_ACTION,
		getInfomationStoreDetail
	);
}

export default getInfomationStoreDetailSaga;
